<template>
  <article class="layout-section -align-side">
    <figure
      v-scroll:reveal="{ delay: 50 }"
      class="layout-section__figure"
      style="background-image: url('/images/home-1.jpg')"
    />

    <section class="layout-section__content">
      <h2 v-scroll:reveal class="layout-section__title">
        {{ wp.about.title }}
      </h2>

      <p v-scroll:reveal="{ delay: 100 }" v-html="wp.about.text" />

      <RouterLink v-scroll:reveal="{ delay: 150 }" :to="{ name: 'about' }" class="button layout-section__cta">
        En savoir plus
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'HomeContent',
  inject: ['wp']
}
</script>
